// /all-trips?section=club-all is the "Events near you" page. With no other
// search params it renders the Luma-style events timeline (home/EventsList)
// instead of the trip grid, and the header drops the trip filters (duration,
// price, styles) — they don't apply to the list. Any extra param (an old
// shared link with filters) keeps the classic grid.
export const EVENTS_LIST_SECTION = "club-all";

const OTHER_SEARCH_PARAMS = [
  "months",
  "destination",
  "search",
  "tab",
  "trip",
  "region",
  "subregion",
  "project",
  "week",
  "duration_min",
  "duration_max",
  "price_min",
  "price_max",
  "adventure_styles",
  "broad_categories",
  "weekend",
];

export const isEventsListView = (params) =>
  !!params &&
  params.get("section") === EVENTS_LIST_SECTION &&
  OTHER_SEARCH_PARAMS.every((key) => !params.get(key));
